export default function(o,p){

  var change = function(field,value,valid){

    p.errors = _.filter(p.errors,function(error){return error.id != field.id})

    if(!valid){
      p.errors.push({id: field.id})
      p.cancel.setDisabled(false)
      p.save.setDisabled(true)
      return
    }

    if((value || value === "" || value === false || value === null) && ((!_.isEqual(field.value,value) || (_.isEqual(field.value,field.init) && !p.item)))){

      var change = _.find(p.changes,{id: field.id})

      if(!change){
        change = {
          id: field.id,
          field: field,
          value: value,
        }
        p.changes.push(change)
      } else {
        change.value = value
      }

    } else {

      p.changes =
        _.filter(p.changes, function(c){
          return c.id != field.id
        })

    }

    if(p.changes.length && !p.errors.length){
      p.save.setDisabled(false)
    } else {
      p.save.setDisabled(true)
    }

    if(p.errors.length || p.changes.length || !p.item){
      p.cancel.setDisabled(false)
    } else {
      p.cancel.setDisabled(true)
    }

    if(p.item && p.model.remove){
      p.remove.setDisabled(false)
    } else {
      p.remove.setDisabled(true)
    }

  }

  return change

}



// WEBPACK FOOTER //
// ./src/client/view/admin/edit/form/change/change.js